import { ApiHelper } from './apiHelper';

export class EmailUpdateApi {
    async UpdateEmail(
        data,
        token,
        successCallback,
        failureCallback,
        signal,
        options = { skipToastNotification: false }
    ) {
        const dataUrl = '/api/EmailUpdateManager/updateEmail';

        await new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            data,
            token,
            successCallback,
            failureCallback,
            signal,
            options
        );
    }
}
